import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

const ServiceFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;

  return (
    <div className="row-between-end gap-4 w-full">
      {/* filter component section */}
      <div className="row-start-center gap-4 w-full">
        <div className="col-start-start gap-1">
          <div className="row-start-center gap-2">
            <i className="pi pi-search text-slate-500 text-xs" />
            <span className="text-sm font-semibold text-slate-500">Nama</span>
          </div>
          <InputText
            value={filterValue.nama}
            onChange={(e) =>
              setFilterValue({ ...filterValue, nama: e.target.value })
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                if (onClickRefresh) onClickRefresh();
              }
            }}
            className="w-full md:w-14rem"
          />
        </div>
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default ServiceFilter;
